import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {HOTB} from "../../HOTB";
import {ExtendedGameMode} from "../../server/ExtendedGameMode";
import {TimelineMax} from "gsap";
import {HOTBGameData} from "../../server/HOTBData";
import {ExtendedGameModel} from "../../server/ExtendedGameModel";
import {GameUtils} from "../../utils/GameUtils";
import {GameSounds} from "../../sound/GameSounds";
import {GameConfig} from "../../GameConfig";

export class NormalIdlePresentation implements FlowStatePresentation {
    private _tl: TimelineMax | undefined;

    constructor() {
    }

    public start(flowStateController: FlowStateController): void {
        GameConfig.isGameIdle = true;
        HOTB.gameBackground.setTanksIdleTimeline();
        const gameData: HOTBGameData = HOTB.model.gameData;

        if (HOTB.soundPlayer.satanSpinSoundPlaying.length) {
            this.handleSatanSpinSounds();
        }

        if (gameData?.nextMode != ExtendedGameMode.NORMAL_AVALANCHE) {
            flowStateController.finish();
            return;
        }
        if (gameData) {
            this._tl = new TimelineMax({repeat: -1});
        } else {
            flowStateController.finish();
        }
    }

    private skip(flowStateController: FlowStateController): void {
        if (this._tl != undefined) {
            this._tl.kill();
            delete this._tl;
            flowStateController.finish();
        }
    }

    private handleSatanSpinSounds(): void {
        const gameModel: ExtendedGameModel = HOTB.model,
            gameData: HOTBGameData = gameModel.gameData,
            nextMode: ExtendedGameMode = gameData?.nextMode;

        if (gameData && GameUtils.isSatanSpin() && nextMode !== ExtendedGameMode.NORMAL_AVALANCHE) {
            HOTB.soundPlayer.stopLoopEffect(HOTB.soundPlayer.satanSpinSoundPlaying);
            HOTB.soundPlayer.playSound(GameSounds.SATAN_SPIN_END);
            HOTB.soundPlayer.satanSpinSoundPlaying = "";
            if (!GameUtils.isBigWin() && (nextMode !== ExtendedGameMode.CAPWIN_GAME)) {
                HOTB.soundPlayer.fadeMusic(1, 0.01);
            }
        }
    }
}